import { render, staticRenderFns } from "./ChatSessionSummary.vue?vue&type=template&id=1b65d151&scoped=true&"
import script from "./ChatSessionSummary.vue?vue&type=script&lang=js&"
export * from "./ChatSessionSummary.vue?vue&type=script&lang=js&"
import style0 from "./ChatSessionSummary.vue?vue&type=style&index=0&id=1b65d151&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65d151",
  null
  
)

export default component.exports